import React from 'react';

export const CustomLogoImage = (props) => {
  const {custom_logo, layout, zIndex = 999} = props;
  const logoData = custom_logo[layout];

  const onLogoClick = (e) => {
    e.preventDefault();
    if (props.showEditLogoDialog) {
      props.showEditLogoDialog();
    }
  };

  if (logoData) {
    const {width = 100, x = 0, y = 0} = logoData;
    const style = {
      position: 'absolute',
      width: `${width}%`,
      left: `${x}%`,
      top: `${y}%`,
      zIndex,
    };

    const img = <img id="custom-logo-img" alt="custom logo" src={custom_logo.url} style={style} />;

    return !props.clickable ? (
      img
    ) : (
      <button className="button-transparent" onClick={onLogoClick}>
        {img}
      </button>
    );
  }

  return null;
};
